import { Link } from 'react-router-dom';

export interface ActivityHistoryItemProps {
  title: string;
  date?: string;
  author?: string;
  note?: string;
  actionLabel?: string;
  actionHref?: string;
}

export const formatActivityDate = (dateStr: string): string => {
  return new Date(dateStr).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

export const ActivityHistoryItem = ({
  title,
  date,
  author,
  note,
  actionLabel,
  actionHref,
}: ActivityHistoryItemProps) => {
  const dateStr = date ? formatActivityDate(date) : '';

  return (
    <div className="gap-3 flex items-center">
      <div className="w-3 h-3 shrink-0 rounded-full bg-text-tertiary" />
      <div className="flex flex-auto items-center justify-between rounded-[6px] bg-canvas-highlight-default p-16">
        <div className="flex items-center gap-8">
          <div className="gap-1 flex min-w-0 flex-1 flex-col">
            <div className="text-base font-bold">{title}</div>
            {(dateStr || author) && (
              <div className="text-xs">
                {dateStr && (
                  <span className="text-text-tertiary">
                    {dateStr}
                    {author ? ' by ' : ''}
                  </span>
                )}
                {author && <span className="font-bold">{author}</span>}
              </div>
            )}
          </div>
          {note !== undefined && (
            <div className="flex flex-col gap-4 border-l-2 border-canvas-inverted py-2 pl-4">
              <div className="text-xs text-text-tertiary">Note:</div>
              {note && <div className="text-base text-text-tertiary">&quot;{note}&quot;</div>}
            </div>
          )}
        </div>
        {actionLabel && actionHref && (
          <Link to={actionHref} className="text-sm font-bold whitespace-nowrap">
            {actionLabel}
          </Link>
        )}
      </div>
    </div>
  );
};
